import { z } from "zod";

export const unitWithKeyResultsSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  title: z.string(),
  symbol: z.string(),
  keyResults: z.array(z.object({ id: z.string() })),
});

export type UnitWithKeyResults = z.infer<typeof unitWithKeyResultsSchema>;

export const unitSchema = unitWithKeyResultsSchema.omit({ keyResults: true });
export type Unit = z.infer<typeof unitSchema>;

export const sortUnit = (a?: Unit | null | undefined, b?: Unit | null | undefined): number => {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  return a.title.localeCompare(b.title);
};
